import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { ProjectTaskColumnsService } from '../../shared/services/project-task-columns.service';

@Component({
  selector: 'project-task-columns-menu',
  standalone: true,
  imports: [MatMenuModule, TranslateModule],
  templateUrl: './project-task-columns-menu.component.html',
  styleUrls: ['./project-task-columns-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectTaskColumnsMenuComponent {
  protected readonly columns = inject(ProjectTaskColumnsService);
}
